module.exports = __webpack_public_path__ + "static/img/passcard.17f51b77.png";